import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { installGlobalErrorHandlers } from "./lib/errorReporter";
import { ErrorBoundary } from "./components/ErrorBoundary";

installGlobalErrorHandlers();

const root = document.getElementById("root")!;

// ⚠️  SEO-CRITICAL — DO NOT simplify this to createRoot().render()
//
// This site uses static HTML prerendering for SEO (see prerender.mjs).
// Every page is pre-built as a real HTML file so Google and AI crawlers
// can read it without executing JavaScript.
//
// hydrateRoot: used when Vercel serves a prerendered page — React attaches
//   to the existing DOM without destroying it (zero flash, no re-render).
// createRoot:  fallback for local dev or any route without a prerendered file.
//
// Reverting to createRoot().render() everywhere would blank the page on load,
// break hydration, and undo all SEO work.
const tree = (
  <HelmetProvider>
    <ErrorBoundary><App /></ErrorBoundary>
  </HelmetProvider>
);

if (root.innerHTML.trim().length > 0) {
  hydrateRoot(root, tree);
} else {
  createRoot(root).render(tree);
}
